import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { SetupService } from '../setup/setup.service';
import { VesselService } from '../vessel/vessel.service';
import { AuthService } from '../../_foundation/services/auth/auth.service';
import { PtLuxonDate } from '../../models/projects/date.models';
import { User } from '../../_foundation/models/security.models';
import { AppConfig } from '../../app/app.config';

@Injectable()
export class JackingActivityReportService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private setupService: SetupService,
    private vesselService: VesselService,
    private authService: AuthService
  ) {

  }

  generateJackingArrivalDownloadLink(date: PtLuxonDate, vesselId: number, jackingActivityId: number, isImplementer: boolean): string {
    // add local offset before sending to api
    const dateLong = date.dateTime.toMillis();

    // tslint:disable-next-line:max-line-length
    return `${this.config.apiUrl}api/jacking/arrival-report/${dateLong}/${vesselId}/${jackingActivityId}/${this.authService.currentUser<User>().id}/${isImplementer}/false/generate-new-jacking-arrival-report`;
  }

  downloadJackingArrivalDownloadLink(date: PtLuxonDate, vesselId: number, jackingActivityId: number, isImplementer: boolean): string {
    // add local offset before sending to api
    const dateLong = date.dateTime.toMillis();

    // tslint:disable-next-line:max-line-length
    return `${this.config.apiUrl}api/jacking/arrival-report/${dateLong}/${vesselId}/${jackingActivityId}/${this.authService.currentUser<User>().id}/${isImplementer}/false/download-jacking-arrival-report`;
  }

  generateJackingDepartureDownloadLink(date: PtLuxonDate, vesselId: number, jackingActivityId: number, isImplementer: boolean): string {
    // add local offset before sending to api
    const dateLong = date.dateTime.toMillis();

    // tslint:disable-next-line:max-line-length
    return `${this.config.apiUrl}api/jacking/departure-report/${dateLong}/${vesselId}/${jackingActivityId}/${this.authService.currentUser<User>().id}/${isImplementer}/false/generate-new-jacking-departure-report`;
  }

  // gets the same file as the generateJackingDepartureDownloadLink method, but doesn't increment the filename version
  downloadJackingDepartureDownloadLink(date: PtLuxonDate, vesselId: number, jackingActivityId: number, isImplementer: boolean): string {
    // add local offset before sending to api
    const dateLong = date.dateTime.toMillis();

    // tslint:disable-next-line:max-line-length
    return `${this.config.apiUrl}api/jacking/departure-report/${dateLong}/${vesselId}/${jackingActivityId}/${this.authService.currentUser<User>().id}/${isImplementer}/false/download-jacking-departure-report`;
  }

  generateFormBlob(url): Observable<HttpResponse<Blob>> {
    return this.http.get<Blob>(url, {
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/jacking-activity/jacking-activity-report.service.ts